import { c as _c } from "react/compiler-runtime";
import { addHours, startOfHour, subDays } from 'date-fns';
import { useContext, useState } from 'react';
import { useHistory } from 'react-router';
import { useTheme } from 'styled-components';
import useSWR from 'swr';
import { SeekPagination } from '../../../../../../../../typings/API.interface';
import { APIDestination, DestinationRateLimitPeriod } from '../../../../../../../../typings/Destination.interface';
import APIMethodKeys from '../../../../../client/APIMethodKeys';
import { formatNumberShorthand } from '../../../../../utils';
import formatMetricsQuery from '../../../../../utils/formatMetricsQuery';
import Badge from '../../../../common/base/Badge';
import Button from '../../../../common/base/Button';
import Icon, { IconName } from '../../../../common/base/Icon';
import Text from '../../../../common/base/Text';
import Tooltip from '../../../../common/base/Tooltip';
import Dropdown from '../../../../common/Dropdown';
import DropdownMenu from '../../../../common/DropdownMenu';
import EmptyState, { EmptyResults, StyledEmptyStateWrapper } from '../../../../common/EmptyState';
import { Div } from '../../../../common/helpers/StyledUtils';
import { buildPreviewBuckets, GROUP_METRICS_BY_2H, GROUP_METRICS_BY_4H, PreviewBucket, PreviewMetricEntry } from '../../../../common/Histogram/PreviewHistogram';
import Table from '../../../../common/Table/Table';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import useMetricsQuery from '../../../../hooks/useMetricsQuery';
import useSearchQuery from '../../../../hooks/useSearchQuery';
import { DashboardContext } from '../../DashboardContext';
import DestinationMetricsPreview from '../List/DestinationMetricsPreview';
import DestinationPreview from '../List/DestinationPreview';
import useOnDisableToggle from '../List/hooks/useOnDisableToggle';
import { StatusBadge } from '../List/StatusBadge';
import { DestinationsListQueryParams } from './DestinationsView';
import { getDestinationDeliveryPolicy } from '../Forms/destination_configuration';
const DestinationUrl = t0 => {
  const $ = _c(14);
  const {
    url,
    path,
    destination,
    mutate
  } = t0;
  const target = url || path || "https://mock.hookdeck.com";
  if (!url && !path && destination?.type !== "MOCK_API") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Text muted={true}>---</Text>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      l: -1.75
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      minWidth: 0
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      min: 408
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== destination.type || $[5] !== target) {
    t4 = (opened, toggle) => <Tooltip fill={true} disabled={destination.type !== "MOCK_API"} tooltip="The URL of mock destination types cannot be edited."><Button ghost={true} active={opened} disabled={destination.type === "MOCK_API"} style={{
        maxWidth: "100%"
      }} onClick={e_0 => {
        toggle(!opened);
        e_0.stopPropagation();
      }}><Text size="s" mono={true} muted={true} ellipsis={true} style={{
          flexGrow: 1
        }}>{target}</Text></Button></Tooltip>;
    $[4] = destination.type;
    $[5] = target;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = ["url"];
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== destination || $[9] !== mutate) {
    t6 = <DestinationPreview destination={destination} fields={t5} mutate={mutate} />;
    $[8] = destination;
    $[9] = mutate;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <Div flex={true} m={t1} min_w={0}><Div onClick={_temp} style={t2}><Dropdown placement="bottom-start" parent_width={t3} portal={true} renderToggle={t4}>{t6}</Dropdown></Div></Div>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
const DestinationName = t0 => {
  const $ = _c(13);
  const {
    name,
    icon,
    destination,
    mutate
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      l: -2
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      minWidth: 0
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      min: 408
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== icon || $[4] !== name) {
    t4 = (opened, toggle) => <Button ghost={true} active={opened} icon={icon} style={{
      maxWidth: "100%"
    }} onClick={e_0 => {
      toggle(!opened);
      e_0.stopPropagation();
    }}><Text as="span" mono={true} ellipsis={true}>{name}</Text></Button>;
    $[3] = icon;
    $[4] = name;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = ["name", "type"];
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== destination || $[8] !== mutate) {
    t6 = <DestinationPreview destination={destination} fields={t5} mutate={mutate} />;
    $[7] = destination;
    $[8] = mutate;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <Div flex={true} m={t1} min_w={0}><Div onClick={_temp2} style={t2}><Dropdown placement="bottom-start" parent_width={t3} portal={true} renderToggle={t4}>{t6}</Dropdown></Div></Div>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
const DestinationConnections = t0 => {
  const $ = _c(27);
  const {
    destination
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const history = useHistory();
  const [is_open, setIsOpen] = useState(false);
  let t1;
  if ($[0] !== destination.id) {
    t1 = APIMethodKeys.webhooks.count({
      destination_id: destination.id
    });
    $[0] = destination.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== HookdeckAPI.webhooks || $[3] !== destination.id) {
    t2 = () => HookdeckAPI.webhooks.count({
      destination_id: destination.id
    });
    $[2] = HookdeckAPI.webhooks;
    $[3] = destination.id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: connections_count
  } = useSWR(t1, t2);
  let t3;
  if ($[5] !== destination.id || $[6] !== is_open) {
    t3 = is_open && APIMethodKeys.webhooks.list({
      destination_id: destination.id
    });
    $[5] = destination.id;
    $[6] = is_open;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== HookdeckAPI.webhooks || $[9] !== destination.id) {
    t4 = () => HookdeckAPI.webhooks.list({
      destination_id: destination.id
    });
    $[8] = HookdeckAPI.webhooks;
    $[9] = destination.id;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const {
    data: connections
  } = useSWR(t3, t4);
  const count = connections_count?.count || 0;
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      l: -2
    };
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = typeof connections === "undefined";
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      min: 300
    };
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== count || $[14] !== destination.id || $[15] !== history) {
    t8 = (opened, toggle) => <Button ghost={true} active={opened} onClick={e_0 => {
      if (count === 0) {
        history.push("/connections/new?destination_id=" + destination.id);
      }
      toggle(!opened);
      e_0.stopPropagation();
    }}><Text muted={count !== 0} neutral={count === 0}>{count === 0 ? "Add " : count}</Text>{count === 0 && <Icon neutral={true} icon="add_circle" pointer={true} m={{
        l: 1
      }} />}</Button>;
    $[13] = count;
    $[14] = destination.id;
    $[15] = history;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== destination.id || $[18] !== history) {
    t9 = () => <Div p={1}><Button w={100} ghost={true} icon="add_circle" onClick={() => {
        history.push("/connections/new?destination_id=" + destination.id);
      }}>New connection</Button></Div>;
    $[17] = destination.id;
    $[18] = history;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== connections?.models) {
    t10 = connections?.models.map(_temp4) || [];
    $[20] = connections?.models;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t6 || $[24] !== t8 || $[25] !== t9) {
    t11 = <Div flex={true} m={t5}><Div onClick={_temp3}><DropdownMenu placement="bottom-end" ghost={true} search={true} search_is_loading={t6} parent_width={t7} onToggle={setIsOpen} renderToggle={t8} getItemsFooter={t9} options={t10} /></Div></Div>;
    $[22] = t10;
    $[23] = t6;
    $[24] = t8;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
};
const DestinationAttempts = t0 => {
  const $ = _c(13);
  const {
    destination,
    timeseries_2h_sample,
    timeseries_4h_sample,
    count
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      align: "center",
      gap: 2
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      px: 40
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = count || 0;
  let t4;
  if ($[2] !== t3) {
    t4 = formatNumberShorthand(t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = <Text w={t2} muted={true} number={true}>{t4}</Text>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== destination || $[7] !== timeseries_2h_sample || $[8] !== timeseries_4h_sample) {
    t6 = <DestinationMetricsPreview ghost={true} data_2h_sample={timeseries_2h_sample} data_4h_sample={timeseries_4h_sample} destination={destination} />;
    $[6] = destination;
    $[7] = timeseries_2h_sample;
    $[8] = timeseries_4h_sample;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <Div flex={t1} min_w={0}>{t5}{t6}</Div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
const formatDeliveryRate = (rate: number, period: DestinationRateLimitPeriod) => {
  if (period === 'concurrent') {
    return `${rate} concurrent`;
  }
  const period_shorthand = {
    second: 's',
    minute: 'm',
    hour: 'h'
  } as const;
  return `${rate}/${period_shorthand[period]}`;
};
const DestinationDeliveryPolicy = t0 => {
  const $ = _c(16);
  const {
    destination,
    mutate
  } = t0;
  let destination_rate_label;
  let t1;
  if ($[0] !== destination) {
    const delivery_policy = getDestinationDeliveryPolicy(destination);
    const delivery_groups = delivery_policy?.groups;
    destination_rate_label = delivery_policy?.rate && delivery_policy.period ? formatDeliveryRate(delivery_policy.rate, delivery_policy.period) : null;
    t1 = delivery_groups ? formatDeliveryRate(delivery_groups.rate, delivery_groups.rate_period) : null;
    $[0] = destination;
    $[1] = destination_rate_label;
    $[2] = t1;
  } else {
    destination_rate_label = $[1];
    t1 = $[2];
  }
  const delivery_group_rate_label = t1;
  let t2;
  bb0: {
    if (!delivery_group_rate_label) {
      t2 = destination_rate_label;
      break bb0;
    }
    if (!destination_rate_label || destination_rate_label === delivery_group_rate_label) {
      t2 = `${delivery_group_rate_label} per group`;
      break bb0;
    }
    t2 = `${destination_rate_label} ⋅ ${delivery_group_rate_label} per group`;
  }
  const delivery_policy_label = t2;
  if (destination.type === "CLI") {
    const t3 = destination_rate_label || "---";
    let t4;
    if ($[3] !== t3) {
      t4 = <Div flex={true}><Tooltip tooltip="CLI destinations do not support rate limiting."><Text muted={true}>{t3}</Text></Tooltip></Div>;
      $[3] = t3;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    return t4;
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      min: 408
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [4, 8];
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== delivery_policy_label) {
    t5 = (opened, toggle) => <Button ghost={true} active={opened} p={1} m={-1} onClick={e_0 => {
      toggle(!opened);
      e_0.stopPropagation();
    }}>{delivery_policy_label ? <Badge neutral={true}>{delivery_policy_label}</Badge> : <Text neutral={true}>+ Add</Text>}</Button>;
    $[7] = delivery_policy_label;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = ["max_delivery_rate"];
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== destination || $[11] !== mutate) {
    t7 = <DestinationPreview destination={destination} fields={t6} mutate={mutate} />;
    $[10] = destination;
    $[11] = mutate;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t7) {
    t8 = <Div flex={true}><Div onClick={_temp5}><Dropdown placement="bottom-start" parent_width={t3} portal={true} offset={t4} renderToggle={t5}>{t7}</Dropdown></Div></Div>;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
const DestinationStatus = t0 => {
  const $ = _c(9);
  const {
    destination,
    mutate
  } = t0;
  const onDisable = useOnDisableToggle("destinations", mutate);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [4, 8];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== destination) {
    t2 = (opened, toggle) => <Button ghost={true} active={opened} m={-1} p={1} onClick={e_0 => {
      toggle(!opened);
      e_0.stopPropagation();
    }}><StatusBadge resource={destination} /></Button>;
    $[1] = destination;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== destination || $[4] !== onDisable) {
    t3 = [destination.disabled_at ? {
      icon: "enable",
      label: "Enable destination",
      description: "Accepts all incoming requests to your destination.",
      onClick: () => onDisable(destination, false)
    } : {
      icon: "disable",
      label: "Disable destination",
      description: "Rejects all incoming requests to your destination.",
      onClick: () => onDisable(destination, true)
    }];
    $[3] = destination;
    $[4] = onDisable;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <Div flex={true}><Div onClick={_temp6}><DropdownMenu placement="bottom-end" ghost={true} offset={t1} renderToggle={t2} icon="horizontal_more" options={t3} /></Div></Div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
type Pagination = SeekPagination & {
  page_size: number;
};
const now = addHours(startOfHour(new Date()), 1);
const DestinationsList = t0 => {
  const $ = _c(49);
  const {
    destinations,
    total,
    loading,
    pagination,
    mutate,
    filtering
  } = t0;
  const [current_page, setCurrentPage] = useState(1);
  const {
    destination_types
  } = useContext(DashboardContext);
  const history = useHistory();
  const theme = useTheme();
  const {
    query: t1,
    updateSearchQuery
  } = useSearchQuery();
  const {
    selected_destination_id
  } = t1;
  let t2;
  if ($[0] !== destinations) {
    const query_params = {
      filters: {
        date: {
          min: subDays(now, 1).toISOString(),
          max: now.toISOString()
        },
        destination_id: destinations?.map(_temp7)
      },
      granularity: "hour" as const,
      measure: ["count", "successful_count", "failed_count"],
      dimensions: ["destination_id"]
    };
    t2 = destinations ? formatMetricsQuery("Attempts", query_params) : null;
    $[0] = destinations;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const metrics_query = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      resetResultSetOnChange: false
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    raw_data
  } = useMetricsQuery(metrics_query, t3);
  let t4;
  let timeseries_2h_by_destination_id;
  if ($[3] !== destinations || $[4] !== raw_data) {
    const entries = raw_data?.flatMap(_temp8) ?? null;
    const destination_ids = destinations.map(_temp9);
    timeseries_2h_by_destination_id = entries && buildPreviewBuckets(destination_ids, entries, GROUP_METRICS_BY_2H, now);
    t4 = entries && buildPreviewBuckets(destination_ids, entries, GROUP_METRICS_BY_4H, now);
    $[3] = destinations;
    $[4] = raw_data;
    $[5] = t4;
    $[6] = timeseries_2h_by_destination_id;
  } else {
    t4 = $[5];
    timeseries_2h_by_destination_id = $[6];
  }
  const timeseries_4h_by_destination_id = t4;
  let t5;
  if ($[7] !== destinations || $[8] !== raw_data) {
    let t6;
    if ($[10] !== raw_data) {
      t6 = (obj, t7) => {
        const {
          id: id_1
        } = t7;
        obj[id_1] = raw_data?.reduce((acc, entry) => {
          if (entry?.["Attempts.destination_id"] === id_1) {
            acc = acc + parseInt(entry?.["Attempts.count"]);
          }
          return acc;
        }, 0);
        return obj;
      };
      $[10] = raw_data;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    t5 = destinations.reduce(t6, {});
    $[7] = destinations;
    $[8] = raw_data;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const count_by_destination_id = t5;
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [{
      min: 100
    }, {
      min: 340,
      max: 340
    }, {
      min: 100,
      max: 100
    }, {
      min: 160,
      max: 160
    }, {
      min: 220,
      max: 220
    }, {
      min: 100,
      max: 100
    }];
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const widths = t6;
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = ["Destination", "Endpoint", "Status", "Attempts (24h)", "Delivery policy", "Connections"];
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const headers = t7;
  let t8;
  if ($[14] !== count_by_destination_id || $[15] !== destination_types || $[16] !== destinations || $[17] !== loading || $[18] !== mutate || $[19] !== selected_destination_id || $[20] !== timeseries_2h_by_destination_id || $[21] !== timeseries_4h_by_destination_id) {
    t8 = loading ? [] : destinations.reduce((rows, destination) => [...rows, {
      id: destination.id,
      selected: selected_destination_id === destination.id,
      highlighted: selected_destination_id === destination.id,
      expendable: false,
      fields: [<DestinationName key={destination.id} name={destination.name} icon={destination_types?.[destination.type]?.icon as IconName || "destination"} destination={destination} mutate={mutate} />, <DestinationUrl key={destination.id} url={(destination.config as any)?.url || ""} path={(destination.config as any)?.path || ""} destination={destination} mutate={mutate} />, <DestinationStatus key={destination.id} destination={destination} mutate={mutate} />, <DestinationAttempts key={destination.id} destination={destination} timeseries_2h_sample={timeseries_2h_by_destination_id?.[destination.id] || []} timeseries_4h_sample={timeseries_4h_by_destination_id?.[destination.id] || []} count={count_by_destination_id?.[destination.id] || 0} />, <DestinationDeliveryPolicy key={destination.id} destination={destination} mutate={mutate} />, <DestinationConnections key={destination.id} destination={destination} />]
    }], []);
    $[14] = count_by_destination_id;
    $[15] = destination_types;
    $[16] = destinations;
    $[17] = loading;
    $[18] = mutate;
    $[19] = selected_destination_id;
    $[20] = timeseries_2h_by_destination_id;
    $[21] = timeseries_4h_by_destination_id;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  const rows_0 = t8;
  let t9;
  if ($[23] !== history) {
    t9 = id_2 => {
      history.push(`/destinations/${id_2}`);
    };
    $[23] = history;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const onRowSelected = t9;
  if (destinations.length === 0 && !loading) {
    if (filtering) {
      let t10;
      if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = <StyledEmptyStateWrapper><EmptyResults label="No destinations found" /></StyledEmptyStateWrapper>;
        $[25] = t10;
      } else {
        t10 = $[25];
      }
      return t10;
    }
    const t10 = `destinations-${theme.mode}.png`;
    let t11;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = {
        label: "Add a destination",
        icon: "add_circle",
        to: "/destinations/new"
      };
      $[26] = t11;
    } else {
      t11 = $[26];
    }
    let t12;
    if ($[27] !== t10) {
      t12 = <EmptyState title="Configure your event endpoints" description="Destinations represent three endpoint types to which your events can be routed: HTTP (public endpoint), CLI (local testing environments), and Mock API (URL that accepts all API requests)." asset={t10} asset_position="background" cta={t11} />;
      $[27] = t10;
      $[28] = t12;
    } else {
      t12 = $[28];
    }
    return t12;
  }
  const t10 = rows_0 as any;
  const t11 = pagination?.page_size || 50;
  let t12;
  if ($[29] !== current_page || $[30] !== t11) {
    t12 = {
      current_page,
      page_size: t11,
      entity_name: "destinations"
    };
    $[29] = current_page;
    $[30] = t11;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== current_page || $[33] !== pagination || $[34] !== updateSearchQuery) {
    t13 = pagination?.next ? () => {
      updateSearchQuery({
        next: pagination.next,
        prev: undefined
      });
      setCurrentPage(current_page + 1);
    } : undefined;
    $[32] = current_page;
    $[33] = pagination;
    $[34] = updateSearchQuery;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== current_page || $[37] !== pagination || $[38] !== updateSearchQuery) {
    t14 = pagination?.prev ? () => {
      updateSearchQuery({
        prev: pagination.prev,
        next: undefined
      });
      setCurrentPage(current_page - 1);
    } : undefined;
    $[36] = current_page;
    $[37] = pagination;
    $[38] = updateSearchQuery;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== destinations.length || $[41] !== loading || $[42] !== onRowSelected || $[43] !== t10 || $[44] !== t12 || $[45] !== t13 || $[46] !== t14 || $[47] !== total) {
    t15 = <Div h={100}><Table fill={true} list={true} headers={headers} widths={widths} top_offset={106} rows={t10} loading={loading} loading_title="Destinations loading" loading_message="It may take a few moments to populate your destinations." onRowSelected={onRowSelected} pagination={t12} onNextPage={t13} onPreviousPage={t14} current_count={destinations.length} total_count={total} /></Div>;
    $[40] = destinations.length;
    $[41] = loading;
    $[42] = onRowSelected;
    $[43] = t10;
    $[44] = t12;
    $[45] = t13;
    $[46] = t14;
    $[47] = total;
    $[48] = t15;
  } else {
    t15 = $[48];
  }
  return t15;
};
export default DestinationsList;
function _temp(e) {
  return e.stopPropagation();
}
function _temp2(e) {
  return e.stopPropagation();
}
function _temp3(e) {
  return e.stopPropagation();
}
function _temp4(connection) {
  return {
    label: connection.full_name,
    to: `/connections/${connection.id}`
  };
}
function _temp5(e) {
  return e.stopPropagation();
}
function _temp6(e) {
  return e.stopPropagation();
}
function _temp7(t0) {
  const {
    id
  } = t0;
  return id;
}
function _temp8(e) {
  return (["successful", "failed"] as const).map(status => ({
    time: new Date(e["Attempts.createdAt"]).getTime(),
    count: parseInt(e[`Attempts.${status}_count`] || "0", 10),
    id: e["Attempts.destination_id"],
    dimension: status
  }));
}
function _temp9(t0) {
  const {
    id: id_0
  } = t0;
  return id_0;
}